import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.numbersOnly", function() {

    var expose = {};

    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function($scope, element, attributes, controller) {

        var validate = function(value) {
            var numbersOnlyValue = value;
            if (! $scope.$eval(attributes.numbersOnlyDisabled)) {
                numbersOnlyValue = $scope.getNumbersOnlyValue(value);
                if (numbersOnlyValue !== value) {
                    controller.$setViewValue(numbersOnlyValue);
                    controller.$render();
                }
            }
            return numbersOnlyValue;
        };

        $scope.getNumbersOnlyValue = function(value) {
            value = (value || "").split(".")[0]; // PAYL-1677 remove the decimal place and anything beyond it
            // \u2022 is allowed to account for the bullet points in the mask directive
            return value.replace(/[^0-9\u2022]/g, "");
        };

        attributes.$observe("numbersOnlyDisabled", function() {
            validate(controller.$viewValue);
        });

        controller.$parsers.unshift(validate);

        controller.$formatters.unshift(function(value) {
            var numbersOnlyValue = value;
            if (! $scope.$eval(attributes.numbersOnlyDisabled)) {
                numbersOnlyValue = $scope.getNumbersOnlyValue(value);
            }
            return numbersOnlyValue;
        });
    };

    return expose;

});
